module.exports = __webpack_public_path__ + "static/media/index.f8da607d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 518
// module chunks = 0